module.exports = __webpack_public_path__ + "img/g_zhongdu.54611939.png";